module.exports = __webpack_public_path__ + "src/img/endtime.b81f98d0.svg";